import PropTypes from "prop-types";
import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import { useToasts } from "react-toast-notifications";
import { getDiscountPrice, getFinalPriceVariation } from "../../../helpers/product";

const MenuCart = ({ cartData, currency, removeFromCart }) => {
  let cartTotalPrice = 0;
  const { addToast } = useToasts();
  return (
    <div className="shopping-cart-content">
      {cartData && cartData.length > 0 ? (
        <Fragment>
          <ul>
            {cartData.map((single, key) => {
              var finalProductPrice = 0;
              if (! single?.variation || single.variation?.length == 0) {
                finalProductPrice = single.price?.toFixed(2);
              } 
              else {
                const discountedPrice = getDiscountPrice(
                  single.price,
                  single.discount, single.pricesco
                );
                finalProductPrice = getFinalPriceVariation(single, single.selectedProductColor, single.selectedProductSize).toFixed(2);
                const finalDiscountedPrice = (
                  discountedPrice * currency.currencyRate
                ).toFixed(2);
              }
              
              cartTotalPrice += finalProductPrice * single.quantity
              /*
              discountedPrice != null
                ? (cartTotalPrice += finalDiscountedPrice * single.quantity)
                : (cartTotalPrice += finalProductPrice * single.quantity);
              */
              return (
                <li className="single-shopping-cart" key={key}>
                  <div className="shopping-cart-img">
                    <Link to={process.env.PUBLIC_URL + "/product/" + single.id}>
                      <img
                        alt=""
                        //src={global.baseUrlImage + single.variation[0].image[0]}
                        id={"image-prod-" + single.id }
                        src={global.baseUrlImage +  (single.variation[0]?.image[0] ? single.variation[0].image[0] :   single.image )}
                        className="img-fluid"
                        onError={() => {
                          var elms = document.querySelectorAll("[id='" + "image-prod-" + single.id + "']");
                          for (var i = 0; i < elms.length; i++) {
                            elms[i].src = global.placeholderImage
                            elms[i].style.objectFit = "contain"
                          }
        
                        }
                        }
                      />

                    </Link>
                  </div>
                  <div className="shopping-cart-title">
                    <h4>
                      <Link
                        to={process.env.PUBLIC_URL + "/product/" + single.id}
                      >
                        {single.sku}{" "}
                      </Link>
                    </h4>

                    <h4>
                      <Link
                        to={process.env.PUBLIC_URL + "/product/" + single.id}
                      >
                        {single.name}{" "}
                      </Link>
                    </h4>
                    <h6>Qtà: {single.quantity}</h6>
                    <span>
                      {currency.currencySymbol + ' ' + finalProductPrice}
                      {/*discountedPrice !== null
                        ? currency.currencySymbol + ' ' + finalDiscountedPrice
                      : currency.currencySymbol + ' ' + finalProductPrice*/}
                    </span>
                    {single.selectedProductColor &&
                      single.selectedProductSize ? (
                      <div className="cart-item-variation">
                        <span>Colore: {single.selectedProductColor}</span>
                        <span>Taglia: {single.selectedProductSize}</span>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="shopping-cart-delete">
                    <button onClick={() => removeFromCart(single, addToast)}>
                      <i className="fa fa-times-circle" />
                    </button>
                  </div>
                </li>
              );
            })}
          </ul>
          <div className="shopping-cart-total">
            <h4>
              Totale :{" "}
              <span className="shop-total">
                {currency.currencySymbol + ' ' + cartTotalPrice.toFixed(2)}
              </span>
            </h4>
          </div>
          <div className="shopping-cart-btn btn-hover text-center">
            <Link className="default-btn" to={process.env.PUBLIC_URL + "/cart"}>
              Visualizza Carrello
            </Link>
            <Link
              className="default-btn"
              to={process.env.PUBLIC_URL + "/precheckout"}
            >
              checkout
            </Link>
          </div>
        </Fragment>
      ) : (
        <p className="text-center">Nessun articolo nel carrello</p>
      )}
    </div>
  );
};

MenuCart.propTypes = {
  cartData: PropTypes.array,
  currency: PropTypes.object,
  removeFromCart: PropTypes.func
};

export default MenuCart;
